// src/modules/requerimiento/components/DatosRequerimientoPlegables.jsx
import React, { useState } from "react";
import { Card, CardActionArea, CardContent, Collapse, Stack, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Grilla, Dato } from "./adicion/EquipoInstaladoDialog";

/** Datos del requerimiento (y de la tercialización) plegados: se consultan poco. */
export default function DatosRequerimientoPlegables({ req }) {
  const [abierto, setAbierto] = useState(false);
  const placas = String(req?.placa ?? "").split(",").map((s) => s.trim()).filter(Boolean);

  return (
    <Card variant="outlined" sx={{ borderRadius: "10px" }}>
      <CardActionArea onClick={() => setAbierto((v) => !v)} sx={{ px: 2, py: 1.25 }}>
        <Stack direction="row" alignItems="center">
          <Typography sx={{ fontWeight: 700, flex: 1 }}>Datos del requerimiento</Typography>
          <KeyboardArrowDownIcon sx={{ transition: "transform .2s", transform: abierto ? "rotate(180deg)" : "none" }} />
        </Stack>
      </CardActionArea>
      <Collapse in={abierto} unmountOnExit>
        <CardContent sx={{ pt: 0.5 }}>
          <Stack spacing={1.5}>
            <Grilla columnas={3}>
              <Dato label="Código"       value={req.cod} />
              <Dato label="Tipo"         value={req.nombre_ot_tipo} />
              <Dato label="Razón social" value={req.razon_social} />
              <Dato label="Solicitante"  value={req.solicitante} />
              <Dato label="Sucursal"     value={req.sucursal} />
              <Dato label="Teléfono"     value={req.telefono} />
              <Dato label={placas.length > 1 ? "Placas" : "Placa"} value={placas.join(", ")} />
            </Grilla>
            {req.descripcion && <Dato label="Descripción" value={req.descripcion} />}
            {req.obs_fin && <Dato label="Obs. final" value={req.obs_fin} />}
            {req.tercia && (
              <>
                <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 700, lineHeight: 1.6 }}>
                  Tercialización
                </Typography>
                <Grilla columnas={3}>
                  <Dato label="Código servicio" value={req.tercia} />
                  <Dato label="Razón social"    value={req.razon_social_tercia} />
                  <Dato label="Descripción"     value={req.descripcion_tercia} />
                </Grilla>
              </>
            )}
          </Stack>
        </CardContent>
      </Collapse>
    </Card>
  );
}
